import { BackendApiClient } from "../../clients/backend-client";
import { Socials } from "../shared/models/players";

export class PlayersRepository {
    private _client: BackendApiClient;

    constructor() {
        this._client = new BackendApiClient('/api/v2/players');
    }

    async updateSocials(request: Socials): Promise<ApiResponse> {
        return await this._client.postOrPutEmptyResponse<Socials>("social", request, 'PUT');
    }
}